import React, {useEffect, useRef, useState} from "react";
import api from "../../services/api";
import {FlashMessage} from "../assets/utils";
import ModalButton from "./ModalButton";
import ModalForm from "./ModalForm";
import HeaderTable from "./HeaderTable";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import SearchInput from "./SearchInput";

const AdminGenres = () => {
    const [genres, setGenres] = useState([])
    const [initialGenre, setInitialGenres] = useState([])
    const [flashMessage, setFlashMessage] = useState(null);
    const [edit, setEditing] = useState(false);
    const genreInputRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [genreName, setGenreName] = useState('');


    const showMessage = (message) => {
        setFlashMessage(message);
    }
    const handleCloseFlashMessage = () => {
        setFlashMessage(null)
    }

    useEffect(() => {
        api.get('/handleGenre').then(response => {
            setGenres(response.data.genres);
            setInitialGenres(response.data.genres);
        })
            .catch(error => {
                    console.log(error);
                }
            )
    }, []);

    const handleSearch = (event) => {
        const search = event.target.value.toLowerCase();
        setGenres(
            search
                ? initialGenre.filter((genre) =>
                    genre.name.toLowerCase().includes(search)
                )
                : initialGenre
        );
    };

    const handleDelete = (id) => {
        api.delete(`/deleteGenre/${id}`).then(response => {
            console.log(response.data);
            setGenres(prevGenres => prevGenres.filter(genre => genre.id !== id));
            showMessage(response.data.message);
        })
            .catch(error => {
                console.error('Error deleting genre:', error);
            });
    }

    const handleEdit = (id) => {
        setEditing(id);
    }

    useEffect(() => {
        if (edit !== null && genreInputRef.current) {
            genreInputRef.current.focus();
        }
    }, [edit]);

    const handleBlur = () => {
        setEditing(null);
    };

    const handleUpdate = (updatedGenre) => {
        api.post(`/updateGenre/${updatedGenre.id}`, updatedGenre)
            .then(response => {
                setGenres((prevGenres) =>
                    prevGenres.map((g) =>
                        g.id === updatedGenre.id ? {...g, name: updatedGenre.name} : g
                    )
                );
                showMessage(response.data.message);
                setEditing(null);
            })
            .catch(error => {
                console.error('Error updating genre:', error);
            });
    };

    const handleChange = (event, genre) => {
        setGenres((prevGenres) =>
            prevGenres.map((g) =>
                g.id === genre.id ? {...g, name: event.target.value} : g
            )
        );
    };

    const handleKeyDown = (event, updatedGenre) => {
        if (event.key === "Enter") {
            handleUpdate(updatedGenre);
        }
    };

    const handleModalStatus = () => {
        setModalOpen(!modalOpen);
    }

    const handleGenreName = (e) => {
        let genre = e.target.value;
        setGenreName(genre);
    }

    const submitNewGenre = () => {
        const formData = new FormData();
        formData.append('name', genreName);

        api.post('/addNewGenre', formData)
            .then(response => {
                setGenres(prevGenres => [...prevGenres, response.data.genre])
                showMessage(response.data.message);
                setGenreName('');
                handleModalStatus()
            })
            .catch(error => {
                console.error('Error adding genre:', error);
            });
    }


    return (
        <>
            <h2 className="text-xl font-bold mb-4">List Of Genres</h2>
            <SearchInput handleSearch={handleSearch}/>
            <table className="min-w-full bg-white shadow-lg rounded-lg overflow-hidden">
                <HeaderTable headers={['Name', 'Edit', 'Delete']}/>
                <tbody>
                {genres.map((genre, index) => (
                    <tr
                        key={genre.id}
                        className={`border-t ${index % 2 === 0 ? "bg-gray-50" : "bg-white"} hover:bg-blue-50 transition duration-200`}
                    >
                        {/* Name Column */}
                        <td className="py-4 px-6 text-gray-800">
                            {edit === genre.id ? (
                                <input
                                    className="border border-gray-300 rounded-lg py-2 px-4 mb-3 w-full max-w-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    ref={genreInputRef}
                                    value={genre.name}
                                    onChange={(event) => handleChange(event, genre)}
                                    onKeyDown={(event) => handleKeyDown(event, genre)}
                                    onBlur={handleBlur}
                                />
                            ) : (
                                <span className="block truncate font-medium">{genre.name}</span>
                            )}
                        </td>
                        <EditButton handleEdit={handleEdit} id={genre.id}/>
                        <DeleteButton handleDelete={handleDelete} id={genre.id}/>
                    </tr>
                ))}
                </tbody>
            </table>
            <ModalButton handleModalStatus={handleModalStatus}/>
            <ModalForm
                modalOpen={modalOpen}
                handleModalStatus={handleModalStatus}
                submitNew={submitNewGenre}
                name={genreName}
                handleName={handleGenreName}
                title="Genre"
            />
            {flashMessage && <FlashMessage
                message={flashMessage}
                duration={2000}
                onClose={handleCloseFlashMessage}
            />}
        </>
    );
}

export default AdminGenres;